import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  standalone: false,
  selector: 'mm-standing-authorizations-input-page',
  templateUrl: './standing-authorizations-input-page.component.html',
  styleUrls: ['./standing-authorizations-input-page.component.scss']
})
export class StandingAuthorizationsInputPageComponent implements OnInit {
  editLinkClicked$: Subject<boolean> = new Subject();
  constructor() { }

  ngOnInit(): void {
  }

  editLinkClickedEvent($event: boolean): void {
    this.editLinkClicked$.next($event);
  }
}
